<template>
    <div class="container-fluid py-4 mt-6 page-shell">
        <div v-loading="loadingTable" class="row g-0">
            <div class="card soft-card soft-table-card">
                <div class="soft-card-header page-header-stats d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div class="d-flex align-items-center flex-wrap gap-3">
                        <div class="d-flex align-items-center gap-2">
                            <i class="bi bi-collection-fill text-info fs-5" aria-hidden="true"></i>
                            <h6 class="mb-0">{{ $t("requestTitle") }}</h6>
                        </div>
                    </div>
                    <div class="header-stat-pills">
                        <div class="header-stat-pill header-stat-pill--total">
                            <i class="bi bi-inbox-fill" aria-hidden="true"></i>
                            <span class="header-stat-pill__label">{{ $t("commonTotal") }}</span>
                            <strong>{{ bulkRequestsCount }}</strong>
                        </div>
                        <div class="header-stat-pill header-stat-pill--new">
                            <i class="bi bi-hourglass-split" aria-hidden="true"></i>
                            <span class="header-stat-pill__label">{{ $t("commonNew") }}</span>
                            <strong>{{ statusCount(0) }}</strong>
                        </div>
                        <div class="header-stat-pill header-stat-pill--approved">
                            <i class="bi bi-check-circle-fill" aria-hidden="true"></i>
                            <span class="header-stat-pill__label">{{ $t("commonApproved") }}</span>
                            <strong>{{ statusCount(1) }}</strong>
                        </div>
                        <div class="header-stat-pill header-stat-pill--rejected">
                            <i class="bi bi-x-circle-fill" aria-hidden="true"></i>
                            <span class="header-stat-pill__label">{{ $t("commonRejected") }}</span>
                            <strong>{{ statusCount(2) }}</strong>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <req-bulk-table
                        :current-page="bulkPage"
                        :max-row="maxRow"
                        :requests-count="bulkRequestsCount"
                        :data-table="bulkRequests"
                        @get-table="getBulkTable"
                        @open-dialog="dialogVisible = true"
                        @open-dialog-excel="dialogExcelVisible = true"
                        @open-dialog-update-info="openOperationDialog('updateInfo')"
                        @open-dialog-program-change="openOperationDialog('programChange')"
                        @open-dialog-terminate="openOperationDialog('terminate')"
                    />
                </div>
            </div>
        </div>
        <!-- <div class="row mt-4">
        <div class="col-12">
          <Table />
        </div>
      </div> -->
    </div>
    <el-dialog v-model="infoDialogVis" :title="$t('insuredChanges')" modal-class="modal-class" width="820px"
        :destroy-on-close="true" align-center>
        <ChangeInfoDialog :info="infoDialogData" @custom-event="closeInfoDialog" />
    </el-dialog>

    <Teleport to="body">
      <div
        v-if="dialogVisible"
        class="account-dual-root"
        @keydown.esc.prevent="closePersonDialog"
      >
        <div class="account-dual-root__mask" aria-hidden="true" />
        <div class="account-dual-root__stage">
          <AccountPersonSearchDialog
            v-model:pin="personSearch.pin"
            v-model:doc-series="personSearch.docSeries"
            v-model:doc-number="personSearch.docNumber"
            v-model:search-mode="personSearch.searchMode"
            embedded
            :model-value="dialogVisible"
            :loading="personSearch.loading"
            @search="triggerPersonSearch"
          />

          <div
            class="account-insured-dialog-panel account-insured-dialog-panel--main account-dual-main-card"
            role="dialog"
            aria-modal="true"
            :aria-label="$t('requestNewInsured')"
          >
            <div class="account-dual-header">
              <span class="account-dual-header__title">{{ $t("requestNewInsured") }}</span>
              <button
                type="button"
                class="account-dual-header__close"
                :aria-label="$t('commonClose')"
                @click="closePersonDialog"
              >
                <i class="bi bi-x-lg" aria-hidden="true"></i>
              </button>
            </div>
            <div class="account-dual-main-body">
              <InsuredDialog
                ref="insuredForm"
                :info="info"
                :search-draft="personSearch"
                :cancel="cancel"
                :edit-data="editInsured"
                @update:search-draft="personSearch = $event"
                @custom-event="closePersonDialog"
                @custom-insert="onPersonInserted"
              />
            </div>
          </div>
        </div>
      </div>
    </Teleport>
    <el-dialog
      v-if="dialogExcelVisible"
      v-model="dialogExcelVisible"
      :close-on-click-modal="false"
      :title="$t('requestNewImport')"
      modal-class="account-insured-overlay"
      class="account-insured-dialog-panel account-insured-dialog-panel--import"
      width="98vw"
      top="1.5vh"
      :destroy-on-close="true"
      append-to-body
    >
      <InsuredImportDialog
        :policy-end-date="policy.endDate"
        @custom-event="dialogExcelVisible = false"
        @custom-insert="onImportExcelSuccess"
      />
    </el-dialog>

    <request-operation-modal
      v-model="opDialogVisible"
      :op-type="opType"
      :policy-id="policy.policyId"
      @success="onOperationSuccess"
    />
</template>

<script>
import { getPolicyId } from "@/project/Source/routes";

import ChangeInfoDialog from "@/project/Global/Modals/ChangeInfoDialog.vue";
import Source from "@/project/Source/claim.js";
import ReqBulkTable from "./components/ReqBulkTable.vue";
import InsuredDialog from "./components/InsuredDialog.vue";
import InsuredImportDialog from "./components/InsuredImportDialog.vue";
import AccountPersonSearchDialog from "./components/AccountPersonSearchDialog.vue";
import RequestOperationModal from "./components/RequestOperationModal.vue";

export default {
    name: "Reports",
    components: {
        ReqBulkTable,
        InsuredDialog,
        InsuredImportDialog,
        AccountPersonSearchDialog,
        ChangeInfoDialog,
        RequestOperationModal,
    },
    data() {
        return {
            accaountAnalitics: [],
            infoDialogVis: false,
            dialogExcelVisible: false,
            operAnalitics: [],
            bulkRequests: [],
            infoDialogData: {},
            dialogVisible: false,
            personSearch: {
                pin: "",
                docSeries: "",
                docNumber: "",
                searchMode: "asan",
                loading: false,
            },
            loadingTable: false,
            bulkRequestsCount: 0,
            bulkPage: 1,
            policy: {},
            maxRow: 10,
            opDialogVisible: false,
            opType: "updateInfo",
        };
    },
    computed: {},
    watch: {
        "$route.query.id"(newVal) {
            if (newVal && Number(newVal) > 0) {
                this.refreshAll();
            }
        },
    },
    beforeMount() {
        const policyId = Number(getPolicyId(this.$route)) || 0;
        if (!policyId) return;
        const list = {
            id: policyId,
            requestCorrelationId: "string"
        };
        this.loadAnalytics();
        Source.Policy(list)
            .then((response) => {
                this.policy = response.data.data?.[0] || {};
                if (this.policy.policyId) {
                    sessionStorage.setItem("policy", JSON.stringify(this.policy.policyId));
                    sessionStorage.setItem(
                        "policyNumber",
                        JSON.stringify(`${this.policy.policySeries}${this.policy.policyNumber}`)
                    );
                }
            })
            .catch((error) => {
                console.error("Policy load failed:", error);
                this.policy = {};
            });

        this.getBulkTable(1);
    },
    mounted() {
        this.onGlobalRefresh = () => {
            this.refreshAll();
        };
        window.addEventListener("app:refresh-data", this.onGlobalRefresh);
    },
    beforeUnmount() {
        if (this.onGlobalRefresh) {
            window.removeEventListener("app:refresh-data", this.onGlobalRefresh);
        }
    },
    methods: {
        getEffectivePolicyId() {
            const val = getPolicyId(this.$route);
            const num = Number(val);
            return num > 0 ? num : 0;
        },
        loadAnalytics() {
            const policyId = this.getEffectivePolicyId();
            if (!policyId) return;
            const list = {
                id: policyId,
                requestCorrelationId: "string"
            };
            Source.AccountStatusAnalitics(list).then((response) => {
                this.accaountAnalitics = response.data.data || [];
            }).catch(() => {
                this.accaountAnalitics = [];
            });
            Source.AccountOperAnalitics(list).then((response) => {
                this.operAnalitics = response.data.data || [];
            }).catch(() => {
                this.operAnalitics = [];
            });
        },
        statusCount(statusNum) {
            if (this.bulkRequests && this.bulkRequests.length) {
                return this.bulkRequests.filter((r) => Number(r.requestStatus) === Number(statusNum)).length;
            }
            const item = this.accaountAnalitics?.[statusNum];
            return item?.status ?? 0;
        },
        resetPersonSearch() {
            this.personSearch = {
                pin: "",
                docSeries: "",
                docNumber: "",
                searchMode: "asan",
                loading: false,
            };
        },
        closePersonDialog() {
            this.dialogVisible = false;
            this.resetPersonSearch();
        },
        onPersonInserted() {
            this.dialogVisible = false;
            this.resetPersonSearch();
            this.refreshAll();
        },
        onOperationSuccess() {
            this.bulkPage = 1;
            this.refreshAll();
        },
        onImportExcelSuccess() {
            this.dialogExcelVisible = false;
            this.bulkPage = 1;
            this.refreshAll();
        },
        triggerPersonSearch() {
            this.$refs.insuredForm?.searchPerson?.();
        },
        openOperationDialog(type) {
            this.opType = type;
            this.opDialogVisible = true;
        },
        getBulkTable(newpage) {
            const policyId = this.getEffectivePolicyId();
            if (!policyId) {
                this.bulkRequests = [];
                this.bulkRequestsCount = 0;
                return;
            }
            this.loadingTable = true;
            this.bulkPage = newpage || this.bulkPage || 1;
            const list = {
                id: policyId,
                requestCorrelationId: "string",
                currentPage: this.bulkPage,
                maxRow: this.maxRow,
            };
            Source.AccountRequestsBulkByPolicy(list)
                .then((response) => {
                    this.bulkRequests = response.data?.data || [];
                    Source.AccountRequestsBulkCountByPolicy(list).then((response2) => {
                        this.bulkRequestsCount = response2.data || (this.bulkRequests ? this.bulkRequests.length : 0);
                    });
                })
                .catch((error) => {
                    console.error("Ошибка загрузки пакетов:", error);
                    this.bulkRequests = [];
                })
                .finally(() => {
                    this.loadingTable = false;
                });
        },
        refreshAll() {
            const policyId = this.getEffectivePolicyId();
            if (!policyId) return;
            this.loadAnalytics();
            this.getBulkTable(this.bulkPage);
        },
        closeInfoDialog() {
            this.infoDialogVis = false;
        },
    }
};
</script>

